const Spacer = () => {
  return (
    <div
      className="bg-secondary"
      style={{ height: 5 }}
      data-html2canvas-ignore="true"
    />
  );
};

export default Spacer;
